import { render, staticRenderFns } from "./cwRightTwo.vue?vue&type=template&id=664bd4da&scoped=true"
import script from "./cwRightTwo.vue?vue&type=script&lang=js"
export * from "./cwRightTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664bd4da",
  null
  
)

export default component.exports